import React from 'react';

const CheckboxFull = () => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.5 6H10.5C8.28 6 6.5 7.8 6.5 10V38C6.5 40.2 8.28 42 10.5 42H38.5C40.72 42 42.5 40.2 42.5 38V10C42.5 7.8 40.72 6 38.5 6ZM20.5 34L10.5 24L13.32 21.18L20.5 28.34L35.68 13.16L38.5 16L20.5 34Z"
      fill="#F99746"
    />
  </svg>
);

export default CheckboxFull;
